import React from 'react';
import PropTypes from 'prop-types';
import { AppraisalTabsContainer } from 'site-modules/shared/components/appraisal/appraisal-tabs-container/appraisal-tabs-container';

export function AppraisalModule({ title, subCopy, headerTag: Heading = 'p', isMobile }) {
  return (
    <div className="appraisal-module">
      <Heading className="size-20 text-cool-gray-10 fw-bold mb-0_5">{title}</Heading>
      <p className="size-16 text-cool-gray-40 mb-1_5">{subCopy}</p>
      <AppraisalTabsContainer
        isFullWidth
        isMobile={isMobile}
        ctaBtnColor="blue-50"
        creativeId="appraisal_vehicle_entry_basic"
        isVdpEmbedded
        isOpenInNewTab
        isLicensePlateTabDefault
        withContainerPadding={false}
        className="border-0 box-shadow-none"
        hideEdmundsLogo
      />
    </div>
  );
}

AppraisalModule.propTypes = {
  title: PropTypes.string.isRequired,
  subCopy: PropTypes.string.isRequired,
  headerTag: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
};
